// 确认弹窗: 支持普通确认 / 永久删(需输入关键词)
import { useState } from 'react';
import { makeT, type Lang } from '../lib/i18n';

export function ConfirmModal({
  lang, title, body, items, confirmLabel, cancelLabel,
  requireType, onConfirm, onCancel,
}: {
  lang: Lang;
  title: string;
  body?: string;
  items?: string[];          // 文件名列表
  confirmLabel: string;
  cancelLabel: string;
  requireType?: string;      // 输入这个关键词才能确认 (永删)
  onConfirm: () => void;
  onCancel: () => void;
}) {
  const [typed, setTyped] = useState('');
  const canConfirm = !requireType || typed === requireType;

  return (
    <div className="modal" onClick={onCancel}>
      <div className="box" onClick={(e) => e.stopPropagation()}>
        <h3>{title}</h3>
        {body && <p>{body}</p>}
        {items && items.length > 0 && (
          <div className="list">
            {items.slice(0, 12).map((it, i) => <div key={i} style={{ padding: '2px 0' }}>• {it}</div>)}
            {items.length > 12 && <div style={{ color: 'var(--muted)', paddingTop: 4 }}>… +{items.length - 12} {lang === 'zh' ? '个' : 'more'}</div>}
          </div>
        )}
        {requireType && (
          <input
            className="input"
            value={typed}
            onChange={(e) => setTyped(e.target.value)}
            placeholder={makeT(lang)('confirm.typeDelete')}
            autoFocus
          />
        )}
        <div className="btns">
          <button className="cancel" onClick={onCancel}>{cancelLabel}</button>
          <button className="confirm" disabled={!canConfirm} onClick={onConfirm}>{confirmLabel}</button>
        </div>
      </div>
    </div>
  );
}
